import { mergeRight, pick } from 'ramda'
import getJsonStoredValue from 'helpers/localStorage/getJsonStoredValue'

export const SECURITY__AUTH_CHECK = 'SECURITY/AUTH_CHECK'
export const SECURITY__AUTH_TOKEN_EXPIRED = 'SECURITY/AUTH_TOKEN_EXPIRED'
export const SECURITY__AUTH_LOGOUT = 'SECURITY/AUTH_LOGOUT'
export const SECURITY__FAILED_AUTH = 'SECURITY/AUTH_FAILED'
export const SECURITY__USER_AUTHENTICATED = 'SECURITY/USER_AUTHENTICATED'
export const SECURITY__START_LOGIN = 'SECURITY/START_LOGIN'

const initialState = {
  error: null,
  token: localStorage.getItem('token'),
  profile: getJsonStoredValue('profile'),
}

const SecurityReducer = (state = initialState, action) => {
  switch (action.type) {
    case SECURITY__USER_AUTHENTICATED:
      return mergeRight(state, pick(['token', 'profile'], action.payload))
    case SECURITY__FAILED_AUTH:
      return mergeRight(state, pick(['error'], action.payload))
    case SECURITY__START_LOGIN:
    case SECURITY__AUTH_TOKEN_EXPIRED:
      return mergeRight(state, { token: null, profile: null })
    default:
      return state
  }
}

export default SecurityReducer
